// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__21loH","img":"styles_img__DvUK_","btn":"styles_btn__3fE_T","checked":"styles_checked__3-cIU","want":"styles_want__10l7T","price_tag":"styles_price_tag__1-lKl"};